import React, { Component } from 'react'
import {FaBars, FaCartPlus} from 'react-icons/fa';

import styled from "styled-components";
import {ProductConsumer} from "../context";

import logo from '../images/logoAta.jpg';
export default class Navbar extends Component {
  render() {

    
    return (
        <>
       <ProductConsumer>
         {value=>{
           const{cartItems,handleSidebar, handleCart}=value;
          

           return <NavWrapper>
             <div className="nav-center">
              <FaBars className="nav-icon" onClick={handleSidebar}/>
              <img className="image" src={logo} alt="tech store logo"/>
              <div className="nav-cart">
              <div className='open-time'>
                <p>Man-Tors : 16.00 - 22.30</p>
                <p>Fredag &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: 16.00 - 02.00</p>    
                <p>Lørdag &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: 12.00 - 02.00</p>
                <p>Søndag &nbsp;&nbsp;&nbsp;&nbsp;: 12.00 - 21.30</p>

              </div>
                <FaCartPlus className="nav-iconcart" onClick={handleCart}/>
                <div className="cart-items">{cartItems}</div>
              </div>
             </div>
           </NavWrapper>
         }}
       </ProductConsumer>
      </>
    )
  }
}

const NavWrapper= styled.nav`
position:-webkit-sticky;
position:sticky;
top:0;
width:100%;
padding:1rem 1.5rem;
background:var(--mainGrey);
border-bottom:3px solid var(--primaryColor);
z-index:1;
.nav-center {
  display:flex;
  align-items:center;
  justify-content:space-between;
  max-width: 1170px;
  margin:0 auto;
}
.nav-icon{
  font-size:1.5rem;
  cursor: pointer;

}
.nav-iconcart{
  font-size:1.5rem;
  cursor: pointer;
  margin-top:50%;

}
.nav-cart{
position:relative;
display: flex;
justify-content: space-between;



}
.cart-items{
  background:var(--primaryColor);
  color: var(--mainWhite);
  font-size:0.85rem;
  position:absolute;
  top:-8px;
  right:-8px;
  padding:0 5px;
  border-radius:50%;
}
.nav-email{
  position: relative;
  margin-right: 10px;
}
.image{
  weight: 15px;
  height: 50px;
   
}
.open-time{
  font-size:0.65rem;
  p{
    margin-bottom:0;
    margin-right:1rem;
    margin-left:-8rem
  }
  @media (max-width: 600px) {
    visibility:hidden;
    }
}
`;